import type { ManualPriceApprovalInput, ManualPriceInput, ManualPriceRejectionInput, ManualPriceRequestView, ProposeLineFromJobInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

export type { ManualPriceRequestView };

/** Off-card pricing of a job (gitaumoses4/chukua#35). The latest request, pending or decided; null before any. */
export function getLatestManualPrice(jobId: string): Promise<ManualPriceRequestView | null> {
  return api<ManualPriceRequestView | null>(`/jobs/${jobId}/manual-price`);
}

export function submitManualPrice(jobId: string, input: ManualPriceInput): Promise<ManualPriceRequestView> {
  return api<ManualPriceRequestView>(`/jobs/${jobId}/manual-price`, { method: 'POST', body: JSON.stringify(input) });
}

export function approveManualPrice(jobId: string, input: ManualPriceApprovalInput): Promise<ManualPriceRequestView> {
  return api<ManualPriceRequestView>(`/jobs/${jobId}/manual-price/approve`, { method: 'POST', body: JSON.stringify(input) });
}

export function rejectManualPrice(jobId: string, input: ManualPriceRejectionInput): Promise<ManualPriceRequestView> {
  return api<ManualPriceRequestView>(`/jobs/${jobId}/manual-price/reject`, { method: 'POST', body: JSON.stringify(input) });
}

/** Offers the approved price to the rate card as a proposal, which lands in the approval queue. */
export async function proposeLineFromManualPrice(jobId: string, input: ProposeLineFromJobInput): Promise<void> {
  await api<unknown>(`/jobs/${jobId}/manual-price/propose-line`, { method: 'POST', body: JSON.stringify(input) });
}
